<template>
  <v-col
    cols="12"
    :md="size === 2 ? 6 : size === 3 ? 4 : undefined"
  >
    <base-card
      :height="value.prominent ? 450 : 350"
      color="grey lighten-1"
      dark
      :href="value.href"
      target="_blank"
    >
      <v-img
        :src="require(`@/assets/articles/${value.foto}`)"
        height="100%"
        gradient="rgba(0, 0, 0, .35), rgba(0, 0, 0, 0)"
      >
        <v-row
          v-if="!value.prominent"
          class="fill-height text-right ma-0"
        >
          <v-col cols="12">
            <v-chip
              label
              class="mx-0 mb-2 text-uppercase"
              color="grey darken-3"
              text-color="white"
              small
              @click.stop=""
            >
              <h3>
                {{ value.title }}
              </h3>
            </v-chip>
           
            <div class="caption">
              {{ value.version }}
            </div>
            <div class="caption">
              {{ value.category }}
            </div>
            <div class="caption">
              {{ value.floor }}
            </div>
            <div class="caption">
              {{ value.size }}
            </div>
            <div class="caption">
              {{ value.pum }}
            </div>
            <div class="caption">
              {{ value.height }}
            </div>

          </v-col>
          
          <v-col align-self="end">
            <v-chip
              class="text-uppercase ma-0"
              color="primary"
              label
              small
              download
            >
              WIĘCEJ INFORMACJI
            </v-chip>
          </v-col>
        </v-row>
      </v-img>
    </base-card>
  </v-col>
</template>

<script>
  export default {
    name: 'FeedCard',

    props: {
      size: {
        type: Number,
        required: true,
      },
      value: {
        type: Object,
        default: () => ({}),
      },
    },
  }
</script>

<style>
.v-image__image {
  transition: .3s linear;
}
</style>
